function converterBytes(bytes) {

  if (typeof bytes !== 'number' || isNaN(bytes)) {
    return bytes;
  }

  const kilobytes = bytes / 1024;
  const megabytes = kilobytes / 1024;
  const gigabytes = megabytes / 1024;

  if (gigabytes >= 1) {
    return `${gigabytes.toFixed(2)} GB`;
  } else if (megabytes >= 1) {
    return `${megabytes.toFixed(2)} MB`;
  } else {
    return `${Math.round(kilobytes)} KB`;
  }
}

export default converterBytes;